import Vue from 'vue'

import {
  getCourseGroup,
  getCourseGroupReplies,
  createCourseGroup,
  deleteCourseGroup,
  createCourseGroupReply
} from "@/api/courseGroup.api";

const getDefaultState = () => ({
  courseGroup: [],
  courseGroupPage: 1,
  courseGroupRepliesPage: {}
})

const state = getDefaultState()

const mutations = {
  pushCourseGroup (state, courseGroup) {
    courseGroup.map(i =>  state.courseGroup.push(i))
  },

  addCourseGroup (state, courseGroup) {
    state.courseGroup.unshift(courseGroup)
  },

  addCourseGroupReply (state, { courseGroupId, courseGroupReply }) {
    const courseGroup = state.courseGroup.find(i => i.id == courseGroupId)

    courseGroup.replies.unshift(courseGroupReply)
  },

  pushCourseGroupReplies (state, { courseGroupId, courseGroupReplies }) {
    const courseGroup = state.courseGroup.find(i => i.id == courseGroupId)

    if (!courseGroup) {
      return null
    }

    courseGroupReplies.map(i => courseGroup.replies.push(i))
  },

  removeCourseGroup ({ courseGroup }, courseGroupId) {
    const index = courseGroup.findIndex(i => i.id == courseGroupId)
    courseGroup.splice(index, 1)
  },

  removeCourseGroupReply ({ courseGroup }, courseGroupId) {
    const courseGroupParent = courseGroup.find(c => {
      return c.replies.map(i => i.id).includes(courseGroupId)
    })

    const courseGroupReplyIndex = courseGroupParent.replies.findIndex(c => {
      return c.id == courseGroupId
    })

    courseGroupParent.replies.splice(courseGroupReplyIndex, 1)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  courseGroup ({ courseGroup }) {
    return courseGroup
  },

  hasCourseGroupMorePages ({ courseGroupPage }) {
    return courseGroupPage !== null
  },

  hasCourseGroupRepliesMorePages ({ courseGroupRepliesPage }) {
    return (courseGroupId) => {
      return courseGroupRepliesPage[courseGroupId] !== null
    }
  },
}

const actions = {
  async fetchCourseGroup({ commit, state, getters }, { data }) {     
    
    if (!getters.hasCourseGroupMorePages) {
      return null
    }

    const response = await getCourseGroup(data.type, data.id, {
      page: state.courseGroupPage++
    })   
   
    commit('pushCourseGroup', response.data)

    if (!response.next_page_url) {
      state.courseGroupPage = null
    }
  },

  async fetchCourseGroupReplies ({ state, commit, getters }, { courseGroupId, courseId }) {
    if (!getters.hasCourseGroupRepliesMorePages(courseGroupId)) {
      return null
    }

    if (typeof state.courseGroupRepliesPage[courseGroupId] === 'undefined') {
      Vue.set(state.courseGroupRepliesPage, courseGroupId, 2)
    }

    const page = state.courseGroupRepliesPage[courseGroupId]
    const response = await getCourseGroupReplies(courseId, courseGroupId, { page: page })
    Vue.set(state.courseGroupRepliesPage, courseGroupId, page + 1)

    if (response.data.length) {
      commit('pushCourseGroupReplies', {
        courseGroupId,
        courseGroupReplies: response.data
      })
    }

    if (!response.next_page_url) {
      Vue.set(state.courseGroupRepliesPage, courseGroupId, null)
    }
  },

  async createCourseGroup(context, data) {   
    await createCourseGroup(data.type, data.courseId, data)
  },

  async createCourseGroupReply(context,  data ) {    
    await createCourseGroupReply(data);
  },

  async deleteCourseGroup ({ commit }, { courseId, courseGroupId }) {
    await deleteCourseGroup(courseId, courseGroupId)
    commit('removeCourseGroup', courseGroupId)
  },

  async deleteCourseGroupReply ({ commit }, { courseId, courseGroupId }) {
    await deleteCourseGroup(courseId, courseGroupId)
    commit('removeCourseGroupReply', courseGroupId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
